/**
 * Represents the request headers accepted by the [[CxmRulesClient]].
 */
export var CxmRulesClientHeader;
(function (CxmRulesClientHeader) {
    /**
     * Determines the response data type, e.g. 'application/json'
     */
    CxmRulesClientHeader["Accept"] = "Accept";
    /**
     * The Global Authentication Service (GAS) token used for authentication.
     */
    CxmRulesClientHeader["Authorization"] = "Authorization";
    /**
     * Determines the response data type, e.g. 'application/json'
     */
    CxmRulesClientHeader["ContentType"] = "Content-Type";
})(CxmRulesClientHeader || (CxmRulesClientHeader = {}));
//# sourceMappingURL=cxm-rules-client-header.js.map